import React from 'react'
import { Popover } from '@mui/material'

export default function PopoverMenu({ children, anchorEl, onClose }) {
    return (
        <Popover
            elevation={3}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            {children}
        </Popover>
    )
}